<div class="d-flex justify-content-center loader-container">
    <div class="spinner-border" role="status">
        <span class="sr-only">Logging you in...</span>
    </div>
    <h1>Logging you in...</h1>
</div>